import { EpgDetailDataSource } from './EpgDetailDataSource';
import { EpgUtil } from '../../utility/EpgUtil';
import { AssetType } from '../../../api/models/Shared.types';
import { Backend } from '../../../api/Backend';
import { IScheduleV5 } from '../../../api/models/AndromeTV.types';
import { EpgApiV5 } from '../../../api/EpgApiV5';

export class ProgramDetailDataSource extends EpgDetailDataSource {
  private scheduleHint: IScheduleV5 | undefined;

  constructor(backend: Backend, scheduleHint?: IScheduleV5) {
    super(backend);
    this.pageType = AssetType.PROGRAM;
    this.scheduleHint = scheduleHint;
  }

  override load(programId: string) {
    return this.initChannels().then(() => {
      let lineupPromise;
      // if the schedule was passed from channelDetailDS, use that
      if (this.scheduleHint) {
        lineupPromise = Promise.resolve({ schedules: [this.scheduleHint] });
      } else {
        const fromuntil = EpgUtil.epgFromUntil(this.backend);
        lineupPromise = EpgApiV5.programLineup(this.backend, programId, fromuntil.from, fromuntil.until);
      }

      return Promise.all([EpgApiV5.program(this.backend, programId), lineupPromise])
        .then(([program, lineup]) => {
          this.program = program.program;
          if (program.series?.text.title) {
            this.series = program.series;
          }
          this.season = program.season;

          this.schedule = EpgUtil.findClosestSchedule(lineup.schedules, false, this.channelsList);

          if (this.schedule) {
            this.channel = this.channelsList?.find(channel => channel.channelId === this.schedule?.channelId);
          } else {
            this.channel = undefined;
          }

          return this.findRecordingForProgram();
        })
        .then(() => {
          return super.load(programId);
        });
    });
  }
}
